import { getReportTags } from '@/lib/api/report-tags';
import { useQuery } from '@tanstack/react-query';
/**
 * Active org diagnosis tags for a scope (`clinic:{id}` / `group:{id}`),
 * for the worklist Diagnosis filter dropdowns. Vocabulary suggestions are
 * filtered out — a filter over rows can only ever match tags that exist.
 */
export function useOrgReportTags(scope) {
    const { data, isLoading } = useQuery({
        queryKey: ['report-tags', scope],
        queryFn: () => getReportTags(scope),
        enabled: !!scope,
        staleTime: 60_000,
    });
    return {
        tags: (data ?? []).filter((t) => t.source !== 'vocabulary'),
        isLoading,
    };
}
